export interface TemplatePosition {
  left: {
    logo?: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
    inscription?: {
      x: number;
      y: number;
      width: number;
      height: number;
      fontSize: number;
    };
  };
  right: {
    logo?: {
      x: number;
      y: number;
      width: number;
      height: number;
    };
    inscription?: {
      x: number;
      y: number;
      width: number;
      height: number;
      fontSize: number;
    };
  };
}

export const templatePositions: Record<string, TemplatePosition> = {
  "sash-1": {
    left: {
      logo: { x: 172, y: 307, width: 88, height: 105 },
      inscription: { x: 171, y: 484, width: 88, height: 91, fontSize: 24 },
    },
    right: {
      logo: { x: 339, y: 310, width: 90, height: 101 },
      inscription: { x: 337, y: 486, width: 89, height: 91, fontSize: 24 },
    },
  },
  "sash-2": {
    left: {
      logo: { x: 172, y: 316, width: 90, height: 90 },
      inscription: { x: 171, y: 484, width: 87, height: 96, fontSize: 26 },
    },
    right: {
      logo: { x: 336, y: 317, width: 90, height: 90 },
      inscription: { x: 335, y: 481, width: 92, height: 99, fontSize: 26 },
    },
  },
  "sash-3": {
    left: {
      logo: { x: 174, y: 307, width: 81, height: 104 },
      inscription: { x: 172, y: 480, width: 86, height: 98, fontSize: 24 },
    },
    right: {
      logo: { x: 338, y: 307, width: 87, height: 105 },
      inscription: { x: 337, y: 482, width: 89, height: 99, fontSize: 24 },
    },
  },
  "sash-4": {
    left: {
      logo: { x: 73, y: 287, width: 171, height: 78 },
      inscription: { x: 75, y: 443, width: 165, height: 181, fontSize: 24 },
    },
    right: {
      logo: { x: 353, y: 283, width: 173, height: 85 },
      inscription: { x: 357, y: 443, width: 166, height: 180, fontSize: 24 },
    },
  },
  "sash-5": {
    left: {
      logo: { x: 81, y: 272, width: 164, height: 93 },
      inscription: { x: 84, y: 430, width: 157, height: 200, fontSize: 24 },
    },
    right: {
      logo: { x: 354, y: 280, width: 159, height: 80 },
      inscription: { x: 356, y: 432, width: 158, height: 191, fontSize: 24 },
    },
  },
  "sash-6": {
    left: {
      logo: { x: 87, y: 430, width: 161, height: 195 },
      inscription: { x: 87, y: 432, width: 161, height: 194, fontSize: 24 },
    },
    right: {
      logo: { x: 350, y: 278, width: 160, height: 90 },
      inscription: { x: 351, y: 430, width: 161, height: 195, fontSize: 24 },
    },
  },
  "sash-7": {
    left: {
      logo: { x: 93, y: 274, width: 154, height: 96 },
      inscription: { x: 95, y: 424, width: 155, height: 201, fontSize: 24 },
    },
    right: {
      logo: { x: 349, y: 277, width: 149, height: 90 },
      inscription: { x: 348, y: 429, width: 154, height: 195, fontSize: 24 },
    },
  },
  "sash-8": {
    left: {
      logo: { x: 81, y: 287, width: 162, height: 85 },
      inscription: { x: 79, y: 441, width: 167, height: 183, fontSize: 24 },
    },
    right: {
      logo: { x: 353, y: 288, width: 164, height: 85 },
      inscription: { x: 351, y: 442, width: 168, height: 183, fontSize: 24 },
    },
  },
  "sash-9": {
    left: {
      logo: { x: 83, y: 278, width: 163, height: 92 },
      inscription: { x: 84, y: 430, width: 162, height: 194, fontSize: 24 },
    },
    right: {
      logo: { x: 350, y: 277, width: 160, height: 97 },
      inscription: { x: 351, y: 426, width: 161, height: 202, fontSize: 24 },
    },
  },
  "sash-10": {
    left: {
      logo: { x: 104, y: 277, width: 143, height: 90 },
      inscription: { x: 105, y: 428, width: 147, height: 197, fontSize: 24 },
    },
    right: {
      logo: { x: 346, y: 279, width: 147, height: 90 },
      inscription: { x: 348, y: 421, width: 146, height: 203, fontSize: 24 },
    },
  },
  "sash-11": {
    left: {
      logo: { x: 104, y: 290, width: 144, height: 71 },
      inscription: { x: 106, y: 440, width: 143, height: 184, fontSize: 24 },
    },
    right: {
      logo: { x: 349, y: 290, width: 142, height: 75 },
      inscription: { x: 350, y: 442, width: 142, height: 183, fontSize: 24 },
    },
  },
  "sash-12": {
    left: {
      logo: { x: 123, y: 274, width: 133, height: 90 },
      inscription: { x: 123, y: 429, width: 132, height: 197, fontSize: 24 },
    },
    right: {
      logo: { x: 345, y: 278, width: 129, height: 90 },
      inscription: { x: 343, y: 430, width: 134, height: 196, fontSize: 24 },
    },
  },
  "sash-13": {
    left: {
      logo: { x: 133, y: 282, width: 124, height: 80 },
      inscription: { x: 132, y: 429, width: 124, height: 199, fontSize: 24 },
    },
    right: {
      logo: { x: 343, y: 282, width: 118, height: 84 },
      inscription: { x: 341, y: 430, width: 125, height: 201, fontSize: 24 },
    },
  },
  "sash-14": {
    left: {
      logo: { x: 117, y: 300, width: 137, height: 81 },
      inscription: { x: 119, y: 437, width: 136, height: 202, fontSize: 24 },
    },
    right: {
      logo: { x: 343, y: 298, width: 134, height: 78 },
      inscription: { x: 344, y: 441, width: 137, height: 200, fontSize: 24 },
    },
  },
  "sash-15": {
    left: {
      logo: { x: 135, y: 272, width: 122, height: 102 },
      inscription: { x: 135, y: 422, width: 125, height: 211, fontSize: 24 },
    },
    right: {
      logo: { x: 340, y: 273, width: 119, height: 101 },
      inscription: { x: 338, y: 416, width: 127, height: 220, fontSize: 24 },
    },
  },
  "sash-16": {
    left: {
      logo: { x: 151, y: 278, width: 111, height: 89 },
      inscription: { x: 151, y: 424, width: 110, height: 201, fontSize: 24 },
    },
    right: {
      logo: { x: 337, y: 276, width: 110, height: 91 },
      inscription: { x: 337, y: 430, width: 110, height: 195, fontSize: 24 },
    },
  },
  "sash-17": {
    left: {
      logo: { x: 159, y: 281, width: 104, height: 86 },
      inscription: { x: 162, y: 427, width: 101, height: 200, fontSize: 24 },
    },
    right: {
      logo: { x: 336, y: 278, width: 100, height: 87 },
      inscription: { x: 334, y: 426, width: 103, height: 203, fontSize: 24 },
    },
  },
  "sash-18": {
    left: {
      logo: { x: 133, y: 262, width: 126, height: 66 },
      inscription: { x: 137, y: 387, width: 119, height: 235, fontSize: 24 },
    },
    right: {
      logo: { x: 340, y: 260, width: 120, height: 71 },
      inscription: { x: 339, y: 384, width: 123, height: 234, fontSize: 24 },
    },
  },
  "sash-19": {
    left: {
      logo: { x: 144, y: 272, width: 115, height: 82 },
      inscription: { x: 146, y: 413, width: 113, height: 218, fontSize: 24 },
    },
    right: {
      logo: { x: 339, y: 272, width: 113, height: 79 },
      inscription: { x: 336, y: 413, width: 120, height: 216, fontSize: 24 },
    },
  },
};

export const getTemplatePositions = (templateId: string): TemplatePosition => {
  return templatePositions[templateId] || templatePositions["sash-1"];
};
